module.exports = __webpack_public_path__ + "static/media/IMG_0824.3f3014cc.jpeg";